import React, { useEffect, useState } from 'react'
import Layout from './layout'
import Chart from './home/chart'
import Hygk from './home/hygk'
import Ltyw from './home/ltyw'
import Zjzk from './home/zjzk'
import Hyjj from './home/hyjj'
import Ltsy from './home/ltsy'
import Qyfc from './home/qyfc'
import Zjxc from './home/zjxc'
import Ztlt from './home/ztlt'
import Ljhd from './home/ljhd'
import Yqlj from './home/yqlj'
import { BASE_URL, getIndexList } from '../api/api'
import useMediaQuery from '../hooks/useMediaQuery'

const Home = () => {
  const [data, setData] = useState([])
  const isMobile = useMediaQuery()

  useEffect(() => {
    getIndexList().then(res => {
      setData(res.data)
      console.log(res)
    })
  }, [])

  if (isMobile) {
    return (
      <Layout>
        {/* <Chart pagePosition="left" data={data.imgList} />
        <Hygk aboutIntro={data.aboutIntro} imgNews={data?.imgNews} impNewsList={data.impNewsList} /> */}
        <Ltyw imgNews={data?.imgNews} impNewsList={data.impNewsList} />
        <Ltsy soundList={data?.soundList} />
        <Qyfc enterpriseList={data?.enterpriseList} />
        <Hyjj meetNewsList={data?.meetNewsList} />
        <Zjxc liveList={data?.liveList} />
        <Ztlt subjectList={data?.subjectList} />
        <Zjzk expertList={data.expertList?.list} />
        <Ljhd sessiontList={data?.sessiontList} />
        <Yqlj linkList={data?.linkList} />
      </Layout>
    )
  }

  return (
    <Layout white>
      <div className="max-w-1200 mx-auto">
        {/* <Chart data={data.imgList} className="mt-8" /> */}
        {/* <Hygk aboutIntro={data.aboutIntro} imgNews={data?.imgNews} impNewsList={data.impNewsList} /> */}
        <Ltyw imgNews={data?.imgNews} impNewsList={data.impNewsList} />
        <div className="mt-[60px]">
          <a target="_blank" href={data?.centralImg?.[0]?.url || '#'} rel="noreferrer">
            <img src={`${BASE_URL}${data?.centralImg?.[0]?.image || ''}`} alt="" />
          </a>
        </div>
      </div>

      {/* <div className="max-w-1200 mx-auto">
        <Hyjj meetNewsList={data?.meetNewsList} />
      </div> */}
      <Ltsy soundList={data?.soundList} />
      <div className="max-w-1200 mx-auto">
        <Qyfc enterpriseList={data?.enterpriseList} />
        <Hyjj meetNewsList={data?.meetNewsList} />
        <Zjxc liveList={data?.liveList} />
      </div>
      <Ztlt subjectList={data?.subjectList} />
      <Zjzk expertList={data.expertList?.list} />
      <div className="max-w-1200 mx-auto">
        <Ljhd sessiontList={data?.sessiontList} />
        <Yqlj linkList={data?.linkList} />
      </div>
    </Layout>
  )
}

export default Home
